"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconClone = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M5.38 18.58v34.59A2.64 2.64 0 0 0 8 55.81h16.12V15.94H8a2.64 2.64 0 0 0-2.62 2.64zm4.5 32.73V20.44h9.73v30.87zM63.65 11a3.3 3.3 0 0 0-2.33-1H29.41a3.26 3.26 0 0 0-1.84.56 3.32 3.32 0 0 0-.49.4 3.27 3.27 0 0 0-1 2.33v45.16a3.3 3.3 0 0 0 3.29 3.29h32.98a3.29 3.29 0 0 0 2.23-3.1V13.3a3.27 3.27 0 0 0-.93-2.3zm-3.53 3.5v42.74h-29.5V14.5z"
  }), _react["default"].createElement("path", {
    d: "M38 37.87h5.34v5.34a2 2 0 0 0 4 0v-5.34h5.34a2 2 0 0 0 0-4h-5.31v-5.34a2 2 0 1 0-4 0v5.34H38a2 2 0 0 0 0 4z"
  })),
  height: undefined,
  width: undefined
});
IconClone.displayName = 'IconClone';
var _default = IconClone;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/clone.js
// module id = 559
// module chunks = 0